/**
 * Guía: Mis Comisiones.
 *
 * Contenido derivado del capítulo **36** del manual: §0 (los cuatro saldos y
 * qué significa cada uno) y del flujo F30 §4.
 *
 * Es la pantalla que ve el asesor de su propio dinero, así que la guía está
 * escrita para él: el paso del «por recuperar» es el que explica la pregunta
 * que más hace.
 */

import type { TourFlow } from '../types';

const MIS_COMISIONES_PATH = '/my-advisor-commissions';

export const c36MisComisiones: TourFlow = {
  id: 'admin.my-advisor-commissions',
  chapter: '36',
  title: 'Mis comisiones',
  summary:
    'Lo que has ganado y lo que te queda por cobrar: los cuatro saldos y por qué no son lo mismo.',
  href: MIS_COMISIONES_PATH,
  estimatedMin: 2,
  steps: [
    {
      id: 'intro',
      title: 'Tu dinero, en cuatro cifras',
      body:
        'Disponible es lo que está listo para entrar en una liquidación. En curso, lo ya ' +
        'comprometido en una que se está procesando. Total ganado es histórico: no es dinero ' +
        'por cobrar.',
      route: MIS_COMISIONES_PATH,
    },
    {
      id: 'clawback',
      title: 'Por qué el disponible puede bajar solo',
      body:
        'Porque una venta que ya te comisionó se devolvió: esa comisión deja de existir. Si ' +
        'ya se te había pagado, queda pendiente de recuperar — y el disponible **ya lo lleva ' +
        'restado**.',
      target: 'admin.myCommissions.balances',
      placement: 'bottom',
      optionalTarget: true,
    },
    {
      id: 'commission-follows-sales',
      title: 'Se comisiona sobre ventas',
      body:
        'Si un comercio tuyo vende menos, tu comisión baja. No hay mínimo garantizado: lo ' +
        'que se cobra sale de lo que esos comercios facturaron en el periodo.',
    },
  ],
};
